import * as React from "react";
import CtaComponent from "@/components/ui/CtaComponent";
import TypographyComponent from "@/components/ui/TypographyComponent";
import { CMSData, CtaComponentProps } from "@/cms/models";
import ContactForm from "@/components/ui/forms/ContactForm";
import { ApplicationFraction } from "@/utils/gql/graphql";
import ImageComponent from "@/components/ui/ImageComponent";
import {
  mergeCtaSettings,
  mergeTypographySettings,
} from "@/utils/theme-helper";
import FlowComponent from "@/components/ui/FlowComponent";
import AssessmentForm from "@/components/ui/forms/AssessmentForm";
import WishForm from "@/components/ui/forms/WishForm";
import SvgComponent from "@/components/ui/SvgComponent";
import GridComponent from "@/components/ui/GridComponent";
import AutoSliderComponent from "@/components/ui/AutoSlider";
import SliderComponent from "@/components/ui/SliderComponent";
import TestimonyListComponent from "@/components/ui/TestimonyListComponent";
import DefaultFooterComponent from "@/components/ui/footer/DefaultFooterComponent";

export const ContentComponents: {
  [key: string]: React.FC<any> | React.LazyExoticComponent<React.FC<any>>;
} = {
  CtaComponent: CtaComponent,
  TypographyComponent: TypographyComponent,
  ImageComponent: ImageComponent,
  SvgComponent: SvgComponent,
  ContactForm: ContactForm,
  FlowComponent: FlowComponent,
  GridComponent: GridComponent,
  AssessmentForm: AssessmentForm,
  WishForm: WishForm,
  AutoSliderComponent: AutoSliderComponent,
  SliderComponent: SliderComponent,
  TestimonyListComponent: TestimonyListComponent,
  DefaultFooterComponent: DefaultFooterComponent,
};

export const GetContentComponent = (
  cmsData: CMSData,
  item: any,
  key: string,
  index: number,
  app: ApplicationFraction
) => {
  const Component = ContentComponents[item.type];
  if (!Component) {
    console.error(`Component type "${item.type}" not found`);
    return <div key={key}>Invalid component type: {item.type}</div>;
  }
  const config = loadConfig(item, cmsData, app, index);
  return <Component key={key} id={key} itemIndex={index} config={config} />;
};

export const loadConfig = (
  item: {
    type: string;
    config: any;
  },
  cmsData: CMSData,
  app: ApplicationFraction,
  index: number
): any => {
  switch (item.type) {
    case "CtaComponent":
      return mergeCtaSettings(item.config as CtaComponentProps, cmsData, {
        size: "sm",
      });
    case "AssessmentForm":
      return { app, cmsData, ...item.config };
    case "ContactForm":
      return { app, cmsData, ...item.config };
    case "WishForm":
      return { app, cmsData, ...item.config };
    case "FlowComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };
    case "GridComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };
    case "AutoSliderComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };
    case "SliderComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };
    case "TestimonyListComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };

    case "DefaultFooterComponent":
      return {
        ...item,
        app,
        cmsData,
        index,
      };

    default:
      return mergeTypographySettings(item.config, cmsData);
  }
};
